import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, CircularProgress, IconButton, Paper, MenuItem, Grid, Tooltip, Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, Skeleton, Chip, Stack, Menu, ListItemIcon, ListItemText } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Replay as ReplayIcon } from '@mui/icons-material';
import { DeletePopUp, PopOverCTA } from '../../../shared_elements/components';
import AuditPopover from '../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Link, useLocation, } from 'react-router';
import SendMail from './SendMail';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment';
import { trackActivity } from '../../../utils/mixpanel';
import UploadingIcon from '../../../shared_elements/components/UploadingIcon';
import { PermissionWrapper } from '../../../wrappers';
import { deleteInvoiceApi, getSummaryInvoiceApi } from '../apiService';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus, setGlobalCookie } from '../../../utils';
import { getInvoiceAuthUrl } from '../apiService';
import { getQbStatusApi } from '../../quickBooks/apiService';
import { enqueueSnackbar } from "notistack";
import { jetstreamAvi, PageLoader, titanAviationIntance, hanwahaInstance } from '../../../shared_elements';
import { handleExport } from '../../../utils/exportFile';
import EXcel from "../../../lease_management/assets/img/xlsx_icon.svg";
import Pdf from "../../../lease_management/assets/img/pdf_icon.svg";
import Docs from "../../../lease_management/assets/img/docx_icon.svg"
import Csv from "../../../lease_management/assets/img/csv.png";
import EditInvoiceModal from './EditInvoiceModal';
import GenerateManagementFeeModal from './GenerateManagementFeeModal';
import { useSelector } from 'react-redux';

const InvoiceActionHeader = ({ onAddLinkedInvoice, onChangeStatus, onRevertStatus, getInvoice, invoiceDetails, viewFile, uploadFileProgressData, uploadedFileData, slug, viewFileStatus, from, getResponseBack, fileUpload, approvalInfo, getTimeLineResponseBack, isMultiApproval }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const [isLoading, setLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [sendMail, setSendMail] = useState({ modal: false, data: {} })
    const [msgModal, setMsgModal] = useState({ modal: false, data: {} })
    const [deleteInvoices, setDeleteInvoices] = useState({ modal: false, item: {}, data: { ids: [] } })
    const [invoiceEdit, setInvoiceEdit] = useState({ modal: false, data: null, mode: '' });
    const [generateMgmtFeeModal, setGenerateMgmtFeeModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isQbEnabled, setIsQbEnabled] = useState(false);
    const [summaryLinkedMsg, setSummaryLinkedMsg] = useState('');
    const open = Boolean(anchorEl);
    const isSummaryLinked = invoiceDetails?.is_summary_linked === true;
    const { permission } = useSelector((state) => state.leases);
    const [managementLinkedMsg, setManagementLinkedMsg] = useState('');
    const leasePermission = permission?.permissions?.lease_revamp_application?.lease_revamp?.lease_details;
    const hasUpdatePermission = Array.isArray(leasePermission) ? leasePermission.includes('U') : false;
    const isRevertTrue = invoiceDetails?.management_fee_invoice?.id ? [3, 5].includes(invoiceDetails?.status?.value) ? true : false : [2, 3, 5].includes(invoiceDetails?.status?.value) && !invoiceDetails?.is_summary_linked && !invoiceDetails?.is_summary_invoice ? true : false;
    const isManagementFee = invoiceDetails?.invoice_type?.value === 10
    const isReserveOrRental = [1, 2].includes(invoiceDetails?.invoice_type?.value)
    const isLinkedChildOfReserveOrRental = [1, 2].includes(invoiceDetails?.child_invoice_type) || [1, 2].includes(invoiceDetails?.linked_invoice_type)
    const isIndependentInvoiceType = [4, 5, 6, 9].includes(invoiceDetails?.invoice_type?.value)
    const isQbSyncEligibleInvoice = isReserveOrRental || (hanwahaInstance && (isLinkedChildOfReserveOrRental || isIndependentInvoiceType))
    const isApprovalExcluded = isManagementFee || !invoiceDetails?.lease_slug || invoiceDetails?.status?.value !== 1
    const isApprovalDecisionApproved = approvalInfo?.groupDecisions?.some(gd => gd.decision?.status === 2)
    const hasInvApprovalPermission = isApprovalExcluded ? false : (isApprovalDecisionApproved ? false : invoiceDetails?.is_invoice_approval)
    // Multi Approval Flow has no single approval_decision - "approved" only once every control stage is approved (already reflected in approvalInfo/isApprovalDecisionApproved).
    const isEditBlockedByApproval = isMultiApproval ? isApprovalDecisionApproved : invoiceDetails?.approval_decision?.status === 2
    
    const menuItemStyle = {
        py: 1,
        px: 2,
        borderRadius: "6px",
        width: '95px',
        padding: '3px 3px 3px 10px',
        mx: 0.5,
        fontSize: "14px",
        "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.08)",
        },
    };
    
    const resolveLeaseSlug = () =>
        invoiceDetails?.lease_slug ||
        (invoiceDetails?.invoice_type?.value === 10 ? sessionStorage.getItem('mgmtFeeLeaseSlug') : null);

    const handleGoBack = () => {
        if (invoiceDetails?.is_summary_invoice) {
            navigate('/invoices', { state: { activeTab: 1 } });
            return;
        }
        const source = getSourceContext();
        if (from === 'viewFromLease' || source === 'viewFromLease' || source === 'editfromleaseInvoice') {
            const leaseSlug = resolveLeaseSlug();
            navigate(leaseSlug ? `/lease/${leaseSlug}/invoices` : '/invoices');
        } else {
            navigate('/invoices');
        }
    };
     
    const getSourceContext = () => {
        const current = location.state?.from;
        const saved = sessionStorage.getItem('invoice_source_context');

        if (current) {
            sessionStorage.setItem('invoice_source_context', current);
            return current;
        }

        return saved;
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `View Invoice`, page_type: page_type, })
    }
    const statusValue = invoiceDetails?.status?.value;
    // Approval flow finishing doesn't change the invoice's own status (it stays Draft) - once approved, show that on the status button so the user isn't left staring at "Draft" after everything's been signed off, while the dropdown still opens the real Draft -> Sent/Void/etc. transition.
    const showApprovedOnDraft = statusValue === 1 && isApprovalDecisionApproved
    const statusLabel = showApprovedOnDraft ? 'Approved' : invoiceDetails?.status?.label
    const statusClass = `invoice-status-button${showApprovedOnDraft ? ' invoice-status-approved' : statusValue ? ` invoice-status-${statusValue}` : ''}`;

    const goToListing = () => {
        const source = location.state?.from;

        const targetPath =
            source === 'editfromleaseInvoice' || from === 'viewFromLease' || source === 'viewFromLease'
                ? `/lease/${resolveLeaseSlug()}/invoices`
                : '/invoices';

        navigate(targetPath, { replace: true });
    };

    useEffect(() => {
        globalGetService(getQbStatusApi()).then(response => {
            if (checkApiStatus(response)) setIsQbEnabled(response.data.data?.is_lessor_enabled || false);
        });
    }, []);

    const handleGoBackRef = useRef(handleGoBack);
    useEffect(() => {
        handleGoBackRef.current = handleGoBack;
    });

    useEffect(() => {
        getSourceContext();
    }, []);

    useEffect(() => {
        window.history.pushState(null, '', window.location.href);

        const onBack = () => handleGoBackRef.current?.();

        window.addEventListener('popstate', onBack);

        return () => {
            window.removeEventListener('popstate', onBack);
        };
    }, []);

    const syncInvoiceToQb = () => {
        if (!invoiceDetails?.id) return;
        setLoading(true);
        globalGetService(getInvoiceAuthUrl({ invoice_id: invoiceDetails.id })).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyInvoiceState', 'SyncInvoiceFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };

    const syncSummaryInvoiceToQb = () => {
        if (!invoiceDetails?.slug) return;
        setLoading(true);
        globalGetService(getInvoiceAuthUrl({ summary_invoice_slug: invoiceDetails.slug })).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyInvoiceState', 'SyncInvoiceFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };

    const onDeleteInvoice = () => {
        setLoading(true);
        const deleteApi = invoiceDetails?.is_summary_invoice ? getSummaryInvoiceApi({}) : deleteInvoiceApi(params);
        globalDeleteService(deleteApi, { ids: [deleteInvoices?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Invoice`, success_msg: response?.data?.message, item_ids: deleteInvoices?.data, response: response?.data })
                    setDeleteInvoices({ modal: false, data: null });
                    handleGoBack();
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Invoice`, error_msg: response?.data?.message, item_ids: deleteInvoices?.data, response: response?.data })
                }
            })
    }

    const handelExport = (format) => {
        const exportName = jetstreamAvi && invoiceDetails?.export_name ? invoiceDetails?.export_name : invoiceDetails?.invoice_number;
        handleExport({
            URL: `invoices/${params?.slug}/export/?export_format=${format}`,
            docType: 'format',
            name: exportName,
            setExportLoader: setIsExporting
        });
    }

    const handelSummaryExport = () => {
        const exportName = jetstreamAvi && invoiceDetails?.export_name ? invoiceDetails?.export_name : invoiceDetails?.invoice_number;
        handleExport({
            URL: `summary-invoices/${params?.slug}/export`,
            docType: 'format',
            name: exportName,
            setExportLoader: setIsExporting
        });
    }
    return (
        <Paper elevation={0} sx={{ padding: '6px 0px 5px 4px', boxShadow: '0px 0px 1px 1px #B8B8B8' }}>
            <Grid container spacing={1} alignItems="center">
                <Grid item size={4}>
                    <span style={{ display: "flex", alignItems: 'center' }}>
                        <Tooltip title="Invoice Listing" arrow> <IconButton onClick={() => { handleGoBack(); handleItemClicked('Invoice Listing Icon') }}> <ArrowCircleLeftOutlinedIcon color="primary" /> </IconButton> </Tooltip>
                        {invoiceDetails?.invoice_type?.label || invoiceDetails?.is_summary_invoice ? (() => {
                            const label = invoiceDetails?.is_summary_invoice ? 'Summary' : invoiceDetails.invoice_type.label;
                            let typeText = "Invoice";

                            if (invoiceDetails.reconcile_invoice && [4, 5].includes(invoiceDetails?.invoice_type?.value)) {
                                typeText = "Note";
                            } else if (invoiceDetails.parent_slug && invoiceDetails.invoice_type.value !== 3 || invoiceDetails.parent_id && invoiceDetails.invoice_type.value !== 3 || invoiceDetails?.linked_invoice_type) {
                                typeText = "Note";
                            } else {
                                typeText = "Invoice"
                            }

                            return (
                                <div>
                                    {invoiceDetails?.asset ?
                                        <Typography className='delivery-header btn-primary' style={{ marginBottom: '3px' }}>
                                            {invoiceDetails?.asset?.name}
                                        </Typography>
                                        : null}
                                    <Typography className='btn-primary' sx={{ letterSpacing: "0", lineHeight: "1", fontSize: "13px", fontFamily: "Roboto-SemiBold", }}>
                                        {label} {typeText}
                                    </Typography>
                                </div>
                            );
                        })() : (
                            <Skeleton variant="text" width={150} height={40} />
                        )}
                    </span>
                </Grid>
                <Grid item size={8}>
                    <ul className="list-inline" style={{ float: "right", alignItems: "center", display: "flex" }} >
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['D'] }}>
                            {[1, 2, 4].includes(invoiceDetails?.status?.value) && !invoiceDetails?.qb_last_sync_by ? <li className="list-inline-item">
                                <Tooltip arrow title="Delete">
                                    <span>
                                        <DeleteIcon
                                            className="invoice-detail-action-icon"
                                            sx={{ pr: 0.8, pt: 0.5, cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.4 : 1 }}
                                            fontSize="small"
                                            onClick={() => {
                                                if (!isLoading) {
                                                    if (isSummaryLinked) {
                                                        setSummaryLinkedMsg('This invoice cannot be deleted because it is linked with a Summary Invoice.');
                                                    } else if  (invoiceDetails?.management_fee_invoice?.slug) {
                                                        setManagementLinkedMsg('This invoice cannot be deleted because it is linked with a Management Fee Invoice.'); 
                                                    } else {
                                                        setDeleteInvoices({ modal: true, data: invoiceDetails });
                                                        handleItemClicked('DeleteIcon');
                                                    }
                                                }
                                            }}
                                            color="error"
                                        />
                                    </span>
                                </Tooltip>
                            </li> : null}
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                            {invoiceDetails?.status?.value === 1 && !invoiceDetails?.is_summary_invoice ? <li className="list-inline-item">
                                <Tooltip title={isEditBlockedByApproval ? 'Cannot edit an approved invoice' : 'Edit'} arrow><EditIcon className="invoice-detail-action-icon" sx={{ pr: 1, pt: 0.5, cursor: isEditBlockedByApproval ? 'not-allowed' : 'pointer' }} fontSize='small' color={isEditBlockedByApproval ? 'disabled' : 'primary'} onClick={() => {
                                    if (isEditBlockedByApproval) return;
                                    if (isSummaryLinked) {
                                        setSummaryLinkedMsg('This invoice cannot be edited because it is linked with a Summary Invoice.');
                                    } else {
                                        setInvoiceEdit({ modal: true, data: invoiceDetails, mode: 'edit' });
                                        handleItemClicked('edit Invoice Button');
                                    }
                                }} /></Tooltip>
                            </li> : null}
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                            {isRevertTrue && !invoiceDetails?.qb_last_sync_by ? <li className='list-inline-item' style={{ marginRight: "8px" }}>
                                <Tooltip title="Revert Status" arrow>
                                    <ReplayIcon fontSize="small" color="primary" onClick={() => { onRevertStatus?.(); handleItemClicked('Revert Status Button') }} sx={{ cursor: "pointer", mt: 0.5 }} />
                                </Tooltip>
                            </li> : null}
                        </PermissionWrapper>
                        {invoiceDetails?.status?.value !== 3 && invoiceDetails?.status?.value !== 4 && hasUpdatePermission && !hasInvApprovalPermission ?
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                <li className='list-inline-item btn-primary' style={{ marginRight: "8px" }}>
                                    <Button size='small' variant='outlined' color='secondary' className={statusClass} disabled={!!invoiceDetails?.qb_last_sync_by} sx={{ "&.Mui-disabled": { pointerEvents: "auto", cursor: "not-allowed" } }} onClick={() => {
                                        if (isSummaryLinked) {
                                            setSummaryLinkedMsg('Status cannot be changed because this invoice is currently linked with a Summary Invoice.');
                                        } else {
                                            onChangeStatus();
                                            handleItemClicked('Change Invoice status Button');
                                        }
                                    }} endIcon={<ArrowDropDownIcon fontSize='small' />}> {statusLabel ? statusLabel : 'Status'} </Button>
                                </li>
                            </PermissionWrapper> :
                            <li className='list-inline-item btn-primary' style={{ marginRight: "8px" }}>
                                <Button size='small' variant='outlined' color='secondary' className={statusClass} sx={{ pointerEvents: 'none', '&:hover': { backgroundColor: 'inherit', borderColor: 'inherit', cursor: 'default' } }} > {statusLabel} </Button>
                            </li>}
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                            {[2, 1].includes(invoiceDetails?.status?.value) ? <li className='list-inline-item revision-history' style={{ marginRight: "8px" }}>
                                <Button size='small' variant='outlined' disabled={!hasUpdatePermission || hasInvApprovalPermission } color='primary' sx={{ "&.Mui-disabled": { pointerEvents: "auto", cursor: "not-allowed" } }} onClick={() => { setSendMail({ modal: true, data: null }); handleItemClicked('Send Mail Button') }} endIcon={<SendIcon fontSize="small" />}>Send Invoice</Button>
                            </li> : null}
                        </PermissionWrapper>
                        {isQbEnabled && !invoiceDetails?.qb_last_sync_by && isQbSyncEligibleInvoice && !invoiceDetails?.is_summary_invoice && !isSummaryLinked && (
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                <li className='list-inline-item btn-primary' style={{ marginRight: "8px" }}>
                                    <Button size='small' variant='contained' color='primary' disabled={invoiceDetails?.status?.value !== 2} onClick={() => { syncInvoiceToQb(); handleItemClicked('Sync to QB Button') }}>Sync to QB</Button>
                                </li>
                            </PermissionWrapper>
                        )}
                        {isQbEnabled && invoiceDetails?.is_summary_invoice && !invoiceDetails?.qb_last_sync_by && (
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                <li className='list-inline-item btn-primary' style={{ marginRight: "8px" }}>
                                    <Button size='small' variant='contained' color='primary' disabled={invoiceDetails?.status?.value !== 2} onClick={() => { syncSummaryInvoiceToQb(); handleItemClicked('Sync to QB Button') }}>Sync to QB</Button>
                                </li>
                            </PermissionWrapper>
                        )}
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['EXP'] }}>
                            <li className='list-inline-item btn-primary' style={{ marginRight: "8px" }}>
                                {invoiceDetails?.is_summary_invoice ? (
                                    <Button
                                        disableRipple
                                        disabled={isExporting}
                                        size='small'
                                        variant='outlined'
                                        color='primary'
                                        onClick={() => { if (!isExporting) { handelSummaryExport(); handleItemClicked('Export Button') } }}
                                        endIcon={isExporting ? <CircularProgress size={14} color="inherit" /> : null}
                                    >Export</Button>
                                ) : (
                                    <>
                                        <Button
                                            disableRipple
                                            disabled={isExporting}
                                            size='small'
                                            variant='outlined'
                                            onClick={(e) => { if (!isExporting) { setAnchorEl(e.currentTarget); handleItemClicked('Export Button') } }}
                                            color='primary'
                                            endIcon={isExporting ? <CircularProgress size={14} color="inherit" /> : <ArrowDropDownIcon fontSize='small' />}
                                        >Export</Button>
                                        <Menu elevation={3} anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                                            <MenuItem sx={menuItemStyle} onClick={() => { handelExport("pdf"); setAnchorEl(null); handleItemClicked('Export PDF') }}>
                                                <ListItemIcon><img src={Pdf} alt="PDF" width={18} height={18} /></ListItemIcon>
                                                <ListItemText primary="PDF" />
                                            </MenuItem>
                                            {!titanAviationIntance && <MenuItem sx={menuItemStyle} onClick={() => { handelExport("excel"); setAnchorEl(null); handleItemClicked('Export Excel')}}>
                                                <ListItemIcon><img src={EXcel} alt="Excel" width={18} height={18} /></ListItemIcon>
                                                <ListItemText primary="Excel" />
                                            </MenuItem>}
                                            {!titanAviationIntance && <MenuItem sx={menuItemStyle} onClick={() => { handelExport("docs"); setAnchorEl(null); handleItemClicked('Export Docs') }}>
                                                <ListItemIcon><img src={Docs} alt="Docs" width={18} height={18} /></ListItemIcon>
                                                <ListItemText primary="Docs" />
                                            </MenuItem>}
                                            {/* <MenuItem sx={menuItemStyle} onClick={() => { handelExport("csv"); setAnchorEl(null); }}>
                                                <ListItemIcon><img src={Csv} alt="CSV" width={18} height={18} /></ListItemIcon>
                                                <ListItemText primary="CSV" />
                                            </MenuItem> */}
                                        </Menu>
                                    </>
                                )}
                            </li>
                        </PermissionWrapper>
                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['C'] }}>
                            {[2, 3, 5].includes(invoiceDetails?.status?.value) && !invoiceDetails?.parent_id && ![4, 5, 6, 10].includes(invoiceDetails?.invoice_type?.value) && !invoiceDetails?.is_summary_invoice ? <li className='list-inline-item' style={{ marginRight: "3px" }}>
                                <PopOverCTA btnText={`Linked Invoices`} onCloseItem={true} >
                                    {!invoiceDetails?.adjustment_invoice_type ? <>
                                        <MenuItem sx={{ minWidth: "154px" }} onClick={() => {
                                            Math.floor(Number(invoiceDetails?.amount)) === Math.floor(Number(invoiceDetails?.linked_invoice_total)) ? setMsgModal({ modal: true }) :
                                                onAddLinkedInvoice({ label: 'Credit Note', value: 5 }); handleItemClicked('Link Credit Note')
                                        }}>Credit Note</MenuItem>
                                        <MenuItem sx={{ minWidth: "154px" }} onClick={() => { onAddLinkedInvoice({ label: 'Debit Note', value: 4 }); handleItemClicked('Link Debit Note') }}>Debit Note</MenuItem>
                                        {invoiceDetails?.can_create_mf_invoice && !invoiceDetails?.management_fee_invoice && <MenuItem sx={{ minWidth: "154px" }} onClick={() => { setGenerateMgmtFeeModal(true); handleItemClicked('Management Fee') }}>Management Fee</MenuItem>}
                                        {moment(invoiceDetails?.paid_date).isAfter(moment(invoiceDetails?.due_date)) && invoiceDetails?.lease_slug && !invoiceDetails?.is_penalty_exists ? <MenuItem onClick={() => { onAddLinkedInvoice({ label: 'Penalty Invoice', value: 3 }); handleItemClicked('Link Penalty Invoice') }}>Penalty Invoice</MenuItem> : null}
                                    </> :
                                        <>
                                            {invoiceDetails?.adjustment_invoice_type?.value === 5 ? <MenuItem sx={{ minWidth: "154px" }} onClick={() => { onAddLinkedInvoice({ label: 'Credit Note', value: 5 }); handleItemClicked('Link Credit Note') }}>Credit Note</MenuItem>
                                                : <MenuItem sx={{ minWidth: "154px" }} onClick={() => { onAddLinkedInvoice({ label: 'Debit Note', value: 4 }); handleItemClicked('Link Debit Note') }}>Debit Note</MenuItem>}
                                        </>}
                                </PopOverCTA>
                            </li> : null}
                        </PermissionWrapper>
                        <li style={{ marginRight: "4px", }}>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['R'] }}>      
                                        <Tooltip title="Attached File(s)" arrow>
                                            <Box sx={{ display: "flex", gap: '1px' }}>
                                                <AttachFileIcon fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                                <Box sx={{ position: "relative", bottom: 8, right: '3px', fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap', }} >
                                                    {invoiceDetails?.attachments?.length > 0 ? `(${invoiceDetails?.attachments?.length})` : null}
                                                </Box>
                                            </Box>
                                        </Tooltip>
                            </PermissionWrapper>
                        </li>
                        {(slug === params?.slug) && <li className='list-inline-item' style={{ marginRight: "8px", marginBottom: "12px" }}><UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /></li>}
                        {isQbEnabled && invoiceDetails?.qb_last_sync_by && isQbSyncEligibleInvoice && !invoiceDetails?.is_summary_invoice && (
                            <li className='list-inline-item btn-primary' style={{ marginRight: "8px" }}>
                                <AuditPopover item={invoiceDetails} syncOnly>
                                    <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} onClick={() => handleItemClicked('QB Sync Info Icon')} />
                                </AuditPopover>
                            </li>
                        )}
                        {isQbEnabled && invoiceDetails?.is_summary_invoice && invoiceDetails?.qb_last_sync_by && (
                            <li className='list-inline-item btn-primary' style={{ marginRight: "8px" }}>
                                <AuditPopover item={invoiceDetails} syncOnly>
                                    <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} onClick={() => handleItemClicked('QB Sync Info Icon')} />
                                </AuditPopover>
                            </li>
                        )}
                    </ul>
                </Grid>
            </Grid>
            {sendMail?.modal ?
                <SendMail
                    onToggleFn={() => setSendMail({ modal: false, data: null })}
                    invoiceDetails={invoiceDetails}
                    getInvoice={getInvoice}
                    getTimeLineResponseBack={getTimeLineResponseBack}
                /> : null}
            {deleteInvoices.modal ?
                <DeletePopUp
                    modal={deleteInvoices.modal}
                    title={'Delete Invoice'}
                    onDeleteRecords={() => onDeleteInvoice()}
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteInvoices({ modal: false, data: null })}
                /> : null}
            {invoiceEdit.modal ?
                <EditInvoiceModal
                    invoiceEdit={invoiceEdit}
                    getInvoice={getInvoice}
                    getResponseBack={getResponseBack}
                    onToggleModal={() => setInvoiceEdit({ modal: false, data: null })}
                    fileUpload={fileUpload}
                /> : null}
            {generateMgmtFeeModal ? <GenerateManagementFeeModal invoiceDetails={invoiceDetails} createFromInv={true} onToggleModal={() => setGenerateMgmtFeeModal(false)} from={from}/> : null}
            {isLoading ? <PageLoader /> : null}
            {summaryLinkedMsg &&
                <Dialog open={true} maxWidth='sm' fullWidth className='add-lease-dialog'>
                    <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>Action Restricted</DialogTitle>
                    <DialogContent dividers>
                        <Typography sx={{ fontSize: 14 }}>{summaryLinkedMsg}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { setSummaryLinkedMsg(''); handleItemClicked('Close Button') }}>Close</Button>
                    </DialogActions>
                </Dialog>
            }
            {managementLinkedMsg &&
                <Dialog open={true} maxWidth='sm' fullWidth className='add-lease-dialog'>
                    <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>Action Restricted</DialogTitle>
                    <DialogContent dividers>
                        <Typography sx={{ fontSize: 14 }}>{managementLinkedMsg}</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { setManagementLinkedMsg(''); handleItemClicked('Close Button') }}>Close</Button>
                    </DialogActions>
                </Dialog>
            }
            {msgModal?.modal ? <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth={"sm"} fullWidth open={true} >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="customized-dialog-title">
                    Note
                </DialogTitle>
                <DialogContent dividers>
                    <Typography sx={{ fontSize: 14 }}>
                        You cannot generate a Credit Note because the Total Amount of the parent invoice
                        has already been fully utilized.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { setMsgModal({ modal: false }); handleItemClicked('Cancel Button') }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog> : null
            }
        </Paper>
    )
}
export default InvoiceActionHeader;